import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Receipt, ExternalLink, Loader2 } from "lucide-react";

export default function PaymentHistory() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/payments/history").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);

  if (rows === null) return <div className="flex justify-center py-6"><Loader2 className="h-5 w-5 animate-spin text-primary" /></div>;

  return (
    <Card className="rounded-2xl border-border p-5 md:p-6" data-testid="payment-history">
      <div className="flex items-center gap-2 font-head font-semibold text-lg mb-1"><Receipt className="h-5 w-5 text-primary" /> Betalningshistorik</div>
      <p className="text-sm text-muted-foreground mb-4">Dina betalningar och kvitton.</p>
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="payment-history-empty">Inga betalningar ännu.</p>
      ) : (
        <div className="divide-y divide-border">
          {rows.map((r) => (
            <div key={r.id} className="flex items-center justify-between gap-3 py-3" data-testid={`payment-row-${r.id}`}>
              <div className="min-w-0">
                <div className="font-medium truncate">{r.plan_name || "Betalning"}{r.kind === "subscription" ? " (abonnemang)" : ""}</div>
                <div className="text-xs text-muted-foreground">
                  {r.created_at ? new Date(r.created_at).toLocaleDateString("sv-SE", { year: "numeric", month: "short", day: "numeric" }) : ""}
                </div>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <span className="font-semibold text-primary">{r.amount} kr</span>
                {r.receipt_url ? (
                  <a href={r.receipt_url} target="_blank" rel="noopener noreferrer" className="text-sm text-primary hover:underline inline-flex items-center gap-1" data-testid={`receipt-link-${r.id}`}>
                    Kvitto <ExternalLink className="h-3.5 w-3.5" />
                  </a>
                ) : (
                  <span className="text-xs text-muted-foreground">Kvitto saknas</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
